import { style } from '@primeuix/styles/iconfield';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-iconfield'
};
var IconFieldStyle = BaseStyle.extend({
  name: 'iconfield',
  style: style,
  classes: classes
});

export { IconFieldStyle as default };
//# sourceMappingURL=index.mjs.map
